import React from "react";
import InputMask from "react-input-mask";
import PropTypes from "prop-types";
import { CpfContainer, StyledInput, ErrorText } from "./CpfInputField.styles";

const CpfInput = ({ value, onChange, error, readOnly }) => {
  return (
    <CpfContainer>
      <label htmlFor="cpf">CPF:</label>
      <InputMask
        mask="999.999.999-99"
        id="cpf"
        name="cpf"
        value={value}
        onChange={onChange}
        placeholder="Digite o CPF"
        as={StyledInput}
        isError={error}
        readOnly={readOnly}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </CpfContainer>
  );
};

CpfInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default CpfInput;
